import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { AuthService } from '@core/services/auth/auth.service';
import { HangfireJob } from '@core/services/hangfire/hangfire.model';
import { HangfireService } from '@core/services/hangfire/hangfire.service';
import { process } from '@progress/kendo-data-query';
import { GridSettings } from '@shared/components/customized-grid/grid-settings/gird-settings.interface';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'Teranet-JobManager',
  templateUrl: './job-manager.component.html'
})
export class JobManagerComponent implements OnInit {
  public gridSettings: GridSettings;
  hangfireJobFormGroup: FormGroup;
  hangfireJobId: number;
  hangfireJobs: HangfireJob[] = [];
  notReadonly = true;
  selected: string;

  constructor(
    private authService: AuthService,
    private hangfireService: HangfireService,
    private spinner: NgxSpinnerService,
  ) {

    if (this.authService.Isauthenticated) {
      if (this.authService.currentUserValue.role === "user") {
        this.notReadonly = false;
      }
    }
    else {
      this.notReadonly = true;
    }

    this.hangfireJobFormGroup = new FormGroup({
      jobName: new FormControl('', Validators.required),
      cronTime: new FormControl('', Validators.required)
    })
  }

  ngOnInit() {
    this.gridSettings = this.gridDefaultSettings();
    this.getHangfireJobs();
  }

  delete(hangFireJob: HangfireJob): void {
    this.hangfireService.deleteHangfireJob(hangFireJob).subscribe(result => {
      if (result) {
        this.getHangfireJobs();
      }
    });
  }

  getHangfireJobs() {
    this.spinner.show();
    this.hangfireService.getHangfireJobs().subscribe(jobs => {
      this.hangfireJobs = jobs as HangfireJob[];
      this.gridSettings.gridData = process(this.hangfireJobs, this.state)
      this.spinner.hide();
    })
  }

  gridDefaultSettings(): GridSettings {
    return {
      state: this.state,
      gridData: process(this.hangfireJobs, this.state),
      columnsConfig: [
        {
          field: 'jobName',
          filterable: true,
          hidden: false,
          includeInChooser: false,
          title: 'Hangfire Job Name',
          width: 170,
        },
        {
          field: 'cronTime',
          filterable: true,
          hidden: false,
          title: 'Cron Time',
          width: 100,
        },
        {
          field: 'hangFireJobId',
          filterable: false,
          hidden: false,
          icon: 'trash-alt',
          includeInChooser: false,
          title: 'Delete',
          type: 'delete',
          width: 40,
        },
      ],
    };
  }

  public state: any = {
    skip: 0,
    take: 8,
    // Initial filter descriptor
    filter: {
      logic: 'and',
      filters: []
    }
  };

  submit(form: NgForm) {

    if (this.hangfireJobFormGroup.valid) {

      let payload: HangfireJob = {
        hangFireJobId: 0,
        jobName: this.hangfireJobFormGroup.get("jobName").value,
        cronTime: this.hangfireJobFormGroup.get("cronTime").value,
      };

      this.hangfireService.createHangfireJob(payload).subscribe(jobId => {
        if (jobId > 0) {
          this.hangfireJobId = jobId;
          this.getHangfireJobs();
        }
      });

      form.resetForm();
    }
  }
}
